<template>
    <div class="company-Main">
        <p class="current">当前位置：<span>安全培训详情</span></p>
        <div class="company-info trainTitle">
            
            <p class="companyName titleP">{{ companyInfo.name }}</p>
            <div v-if="!widthNew" class="dataTime">
                <p class="descriWidth">时间：</p>
                <p class="descriWidth">{{ companyInfo.update_time }}~{{ companyInfo.end_time }}</p>
            </div>
            <p  v-if="widthNew" class="descri">时间：{{ companyInfo.update_time }}~{{ companyInfo.end_time }}</p>
             <div class="trainImage"  :style="'background-image:url('+companyInfo.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;margin: 20px auto'"></div>
           
            <div class="company-detail">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="详细介绍" name="1">
                        <div v-html="companyInfo.intro" class="introinfo"></div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="flex-bottom">
                <el-button type="primary" @click="Application()">立即报名<span>￥{{ companyInfo.price }}</span></el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default({
    data(){
        return {
            companyInfo: [],
            activeNames: ['1'],
            companyproduct: [],
            widthNew: false
        }
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        getTimeDate(timeDate){
            const year = timeDate.getFullYear();
                const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
                const day = timeDate.getDate().toString().padStart(2, '0');
                const hours = timeDate.getHours().toString().padStart(2, '0');
                const minutes = timeDate.getMinutes().toString().padStart(2, '0');
                const seconds = timeDate.getSeconds().toString().padStart(2, '0');
                const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                return formattedDate
        },
        Application(){
            this.$router.push({
                path: '/application',
                query: {
                    key: this.companyInfo.id
                }
            })
        }
    },
    mounted(){
        let data = {
            id: this.$route.query.key
        }
        console.log("第一步");
        
        this.$store.dispatch('train/trainInfo',data)
            .then(res => {
                if(res.ok){
                    this.companyInfo = res.data

                    const update_time = new Date(this.companyInfo.update_time)
                    const end_time = new Date(this.companyInfo.end_time)
                    this.companyInfo.update_time = this.getTimeDate(update_time)
                    this.companyInfo.end_time = this.getTimeDate(end_time)
                }
            })
        
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
    }

})
</script>

<style scoped>
@import url(../../css/info.css);
.trainImage{
    width: 1100px; height: 500px;
}
@media screen and (max-width: 540px) {
    .company-Main{
        
        padding-bottom: 70px;
        position: relative;
    }
    .descriWidth{
        margin-left: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        color: #666666;
        text-align: left;
        margin-top: 5px;
       
    }
    .dataTime{
        margin-top: 10px;
        padding-bottom: 15px;
        border-bottom: 0.5px solid #f2f2f2;
    }
    .trainImage{
        width: 96%; height: 200px;
        margin: 20px auto;
    }
    .flex-bottom{
        position: absolute;
        bottom: 20px;
        left: 50px;
        width: 300px;height: 40px;
    }
}
</style>
